import { Column, Text } from "@/components";

// The goal line, with its value parked above the right end of it.
export const ComparisonGoalLine = ({
  label,
  topPercent,
}: {
  label: string;
  topPercent: number;
}) => (
  <Column
    className="pointer-events-none absolute inset-x-0 z-30"
    style={{ top: `${topPercent.toString()}%` }}
  >
    <Column className="absolute right-1 -translate-y-full items-end">
      <Text className="font-lever-accent text-[9px] font-medium uppercase tabular-nums tracking-wider text-lever-text-label">
        {label}
      </Text>
    </Column>
    <Column className="h-px w-full bg-[repeating-linear-gradient(to_right,rgb(var(--lever-icon-label)/0.45)_0_4px,transparent_4px_7px)]" />
  </Column>
);
